import axios from 'axios';
import global_data from './main';
const OCGlobal = {
    install(Vue, options) {
        Vue.prototype.FixMenuLinks = function(){
            $("#menu1 a").click(function(){
                var href = $(this).attr("href");
                if (href.indexOf('#') < 0) {
                    return true;
                }

                var hrefPath = href.substr(0, href.indexOf('#'));
                var path = window.location.pathname;

                if (hrefPath != path) {
                    return true;
                }

                var hrefHashPathWithQuery = href.substr(href.indexOf('#'));
                var hrefHashPath = hrefHashPathWithQuery.substr(0, hrefHashPathWithQuery.indexOf('?'));
                var hash = window.location.hash;
                var hashPath = hash.substr(0, hash.indexOf('?'))

                if (hrefHashPath == hashPath) {
                    window.location.href = $(this).attr("href");
                    window.location.reload(true);
                    return false;
                }
                return true;
            });
        }
        Vue.prototype.FixMenuLinks();
        
        Vue.prototype.APIBaseURL = function() {
            if (window.location.hostname == "www.odonatacentral.org" || window.location.hostname == "odonatacentral.org") {
                return "https://api.odonatacentral.org/";
            }
            return "https://ocapi.staging.birdsinthehand.com/";
        },
        Vue.prototype.APIStatuses = {
            accpeted: 1,
            declined: 2,
            pending: 3,
        },
        Vue.prototype.scrollTo = function (selector){
            $([document.documentElement, document.body]).animate({
                scrollTop: $(selector).offset().top - 120
            }, 500);
        }
        Vue.prototype.APIFullURL = function(input_options){
            var defaults = {
                endpoint: '',
                querystring: '',
                funcThen: function() {},
                funcCatch: function(error) {
                    console.log(error);
                },
                funcAfterThen: function() {},
                isPost: false,
                isPut: false,
                isDelete: false,
                isPatch: false,
                postData: null
            };
            var options = $.extend({}, defaults, input_options);
            if (typeof options.endpoint == 'undefined' || options.endpoint == "") {
                console.log("endpoint cannot be empty");
                return;
            }

            var url = Vue.prototype.APIBaseURL();
            url += options.endpoint + '/';
            url += '?format=json';
            if (typeof options.querystring !== 'undefined') {
                url += options.querystring;
            }
            return url;
        }
        Vue.prototype.API = function(input_options) {
            var defaults = {
                endpoint: '',
                querystring: '',
                funcThen: function() {},
                funcCatch: function(error) {
                    console.log(error);
                },
                funcAfterThen: function() {},
                isPost: false,
                isPut: false,
                isDelete: false,
                isPatch: false,
                postData: null
            };
            var options = $.extend({}, defaults, input_options);
            if (typeof options.endpoint == 'undefined' || options.endpoint == "") {
                console.log("endpoint cannot be empty");
                return;
            }
            var url = Vue.prototype.APIFullURL(input_options);
            var method = 'get';
            if (options.isPost) {
                method = 'post';
            } else if (options.isPut) {
                method = 'put';
            } else if (options.isDelete) {
                method = 'delete';
            } else if (options.isPatch) {
                method = 'patch';
            }

            var headers = {};
            if (this.$cookie.get('OCAuth') != null) {
                headers['Authorization'] = 'Token ' + this.$cookie.get('OCAuth');
            }
            if (options.isPut || options.isPost || options.isPatch) {
                headers['UTC-Offset'] = (new Date()).getTimezoneOffset() * -1;
            }
            return axios({
                method: method,
                url: url,
                headers: headers,
                data: options.postData
            }).then(options.funcThen).catch(options.funcCatch).then(options.funcAfterThen);
        },
        Vue.prototype.GetAPIUser = function(callback, include_favorites, include_all_locations) {
            if (typeof(include_favorites) == undefined) {
                include_favorites = false;
            }
            if (typeof(include_all_locations) == undefined) {
                include_all_locations = false;
            }

            if (!include_favorites && global_data.OCUser != null) {
                callback(global_data.OCUser);
                return;
            }
            if (!this.$cookie.get('OCAuth')) {
                callback(null);
                return;
            }
            var qs = '';
            if (include_favorites) {
                qs += "&include[]=profile.favorite_locations.*";
            }
            if (include_all_locations) {
                qs += "&include[]=profile.locations.*";
            }

            Vue.prototype.API({
                endpoint: 'user',
                querystring: qs,
                funcThen: function(response) {
                    $('.dd-browse-records').find('.user-navigation').remove();
                    if (response.data.user) {
                        if (!include_favorites) {
                            global_data.OCUser = response.data.user;
                        }
                        if (response.data.user.profile.vetter) {
                            $('.dd-browse-records').append('<li class="user-navigation"><a href="/app/#/data/records/?filterqs=%7Cexcludedotmap%7Cvettableonly%7Cpendingonly%7Clifestages%3A1">Vet Records</a></li>');
                            for (var i = 0; i < response.data.user.groups.length; i++) {
                                if (response.data.user.groups[i].name == "Administrator") {
                                    $('.dd-browse-records').append('<li class="user-navigation"><a href="/app/#/data/batchupload/">Add &amp; Manage Bulk Uploads</a></li>');
                                    break;
                                }
                            }
                            Vue.prototype.FixMenuLinks();
                        }
                        callback(response.data.user);
                    } else {
                        callback(response.null);
                    }
                },
                funcCatch: function(response){
                    Vue.prototype.LogoutUser();
                    Vue.prototype.$notify({
                        text: 'Your session has ended.',
                        type: 'error',
                    });
                }
            });
        },
        Vue.prototype.LogoutUser = function() {
            this.$cookie.delete('OCAuth');
            global_data.OCUser = null;
        },
        Vue.prototype.CombineSightingData = function(data){
        	for (var i = 0; i < data.sightings.length; i++) {
		        data.sightings[i].checklist_data = data.checklists.find(c => c.id == data.sightings[i].checklist);
		        data.sightings[i].user_data = data.users.find(u => u.id == data.sightings[i].checklist_data.user);
		        data.sightings[i].location_data = data.locations.find(u => u.id == data.sightings[i].checklist_data.location);
		        data.sightings[i].jurisdiction_data = data.locations.find(u => u.id == data.sightings[i].location_data.parent);
		        data.sightings[i].taxon_data = data.taxa.find(u => u.id == data.sightings[i].taxon);
                data.sightings[i].status_data = data.sighting_statuses.find(s => s.id == data.sightings[i].status);
                if (data.life_stages) {
                    data.sightings[i].life_stage_data = data.life_stages.find(s => s.id == data.sightings[i].life_stage);
                }
		    }
		    return data.sightings;
        },
        Vue.prototype.iNatAPI = function(input_options) {
            var defaults = {
                endpoint: '',
                funcThen: function() {},
                funcCatch: function(error) {
                    console.log(error);
                },
                funcAfterThen: function() {},
            };
            var options = $.extend({}, defaults, input_options);
            if (typeof options.endpoint == 'undefined' || options.endpoint == "") {
                console.log("endpoint cannot be empty");
                return;
            }
            return axios({
                method: 'get',
                url: "https://api.inaturalist.org/v1/" + options.endpoint,
            }).then(options.funcThen).catch(options.funcCatch).then(options.funcAfterThen);
        },
        Vue.prototype.formatDate = function(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;

            return [year, month, day].join('-');
        },
        Vue.prototype.momentDisplayFormat = function(){
            return "DD MMM YYYY"; //20 Jan 2019
        }
    }
};
export default OCGlobal;


// WEBPACK FOOTER //
// ./src/OCGlobal.js